export const namespaced = true

/*
* localSetting är för inställningar som sparas lokalt på enheten, består mellan olika inloggade sessioner
* REVIEW: skulle kunna göra en SESSION_SETTING också för inställningar som bara gäller per inloggad session, men det är inte alltid så tydligt om man vill att en inställning gäller alla eller inte
*/

export const state = {
  bookingsListCheckinsShowNights: false,
  bookingsListCheckoutsShowNights: false,
  bookingsListCheckinsShowPositionNameFirst: false,
  bookingsListCheckoutsShowPositionNameFirst: false,
  recentBookingsShowNights: false,
  recentBookingsShowCheckinCheckoutDates: true,
  recentBookingsShowPositionNameFirst: true,
  recentCheckinsCheckoutsShowNights: false,
  recentCheckinsCheckoutsShowCheckinCheckoutDates: false,
  recentCheckinsCheckoutsShowPositionNameFirst: false,
  bookingsListCheckinsShowCheckinCheckoutDates: false,
  bookingsListCheckoutsShowCheckinCheckoutDates: false,
  bookingsListCheckinsShowRemaining: true,
  bookingsListCheckoutsShowRemaining: true,
  bookingsListCheckinsShowUnpaid: true,
  bookingsListCheckoutsShowUnpaid: true,
  bookingFormAlwaysShowMap: false,
  bookingFormAlwaysSendConfirmationEmail: false,
  bookingFormCategoryFilterDropdown: false,
  bookingCalendarIsToggleLongPositionName: false,
  bookingCalendarIsToggleShowArea: false,
  statsProductGroupSalesTableSettingShowRegisterSalesOnly: false,
  mapPositionsGreenAvailability: true, // Lediga platserna på kartan är lediga (false = vita)
  calendarCategoryFilterDropdown: false,
  calendarShowTwelveMonthsQuickScroll: false,
  calendarPreservePositionInGrid: false, // Behåll scrollposition i kalendern vid omladdning/navigering
  calendarPreserveCategoryFilter: false, // Behåll filter i kalendern vid omladdning/navigering
  calendarShowPositionReservationLocks: true,
  calendarNarrowRows: 3, // 1 = smal, 2 = normal, 3 = bred
  calendarEventColorScheme: 'status',
  showParkAsNoteFirst: false, // Om true visas "Parkera som nota" först i parkeringsdialogen, annars "Parkera på bokning"
  printCheckinConfirmationAutomatically: false, // Om true skrivs incheckningsbekräftelse ut automatiskt vid incheckning
  cashCalculatorShowOnScreenButtons: true,
  cashCalculatorShowDenominations: false
}

export const mutations = {
  SET_BOOKINGS_LIST_CHECKINS_SHOW_NIGHTS (state, val) {
    state.bookingsListCheckinsShowNights = val
    localStorage.setItem('LOCAL_SETTING_BOOKINGS_LIST_CHECKINS_SHOW_NIGHTS', val ? '1' : '0')
  },
  SET_BOOKINGS_LIST_CHECKOUTS_SHOW_NIGHTS (state, val) {
    state.bookingsListCheckoutsShowNights = val
    localStorage.setItem('LOCAL_SETTING_BOOKINGS_LIST_CHECKOUTS_SHOW_NIGHTS', val ? '1' : '0')
  },
  SET_BOOKINGS_LIST_CHECKINS_SHOW_POSITION_NAME_FIRST (state, val) {
    state.bookingsListCheckinsShowPositionNameFirst = val
    localStorage.setItem('LOCAL_SETTING_BOOKINGS_LIST_CHECKINS_SHOW_POSITION_NAME_FIRST', val ? '1' : '0')
  },
  SET_BOOKINGS_LIST_CHECKOUTS_SHOW_POSITION_NAME_FIRST (state, val) {
    state.bookingsListCheckoutsShowPositionNameFirst = val
    localStorage.setItem('LOCAL_SETTING_BOOKINGS_LIST_CHECKOUTS_SHOW_POSITION_NAME_FIRST', val ? '1' : '0')
  },
  SET_RECENT_BOOKINGS_SHOW_NIGHTS (state, val) {
    state.recentBookingsShowNights = val
    localStorage.setItem('LOCAL_SETTING_RECENT_BOOKINGS_SHOW_NIGHTS', val ? '1' : '0')
  },
  SET_RECENT_BOOKINGS_SHOW_POSITION_NAME_FIRST (state, val) {
    state.recentBookingsShowPositionNameFirst = val
    localStorage.setItem('LOCAL_SETTING_RECENT_BOOKINGS_SHOW_POSITION_NAME_FIRST', val ? '1' : '0')
  },
  SET_RECENT_CHECKINS_CHECKOUTS_SHOW_NIGHTS (state, val) {
    state.recentCheckinsCheckoutsShowNights = val
    localStorage.setItem('LOCAL_SETTING_RECENT_CHECKINS_CHECKOUTS_SHOW_NIGHTS', val ? '1' : '0')
  },
  SET_RECENT_CHECKINS_CHECKOUTS_SHOW_POSITION_NAME_FIRST (state, val) {
    state.recentCheckinsCheckoutsShowPositionNameFirst = val
    localStorage.setItem('LOCAL_SETTING_RECENT_CHECKINS_CHECKOUTS_SHOW_POSITION_NAME_FIRST', val ? '1' : '0')
  },
  SET_RECENT_BOOKINGS_SHOW_CHECKIN_CHECKOUT_DATES (state, val) {
    state.recentBookingsShowCheckinCheckoutDates = val
    localStorage.setItem('LOCAL_SETTING_RECENT_BOOKINGS_SHOW_CHECKIN_CHECKOUT_DATES', val ? '1' : '0')
  },
  SET_RECENT_CHECKINS_CHECKOUTS_SHOW_CHECKIN_CHECKOUT_DATES (state, val) {
    state.recentCheckinsCheckoutsShowCheckinCheckoutDates = val
    localStorage.setItem('LOCAL_SETTING_RECENT_CHECKINS_CHECKOUTS_SHOW_CHECKIN_CHECKOUT_DATES', val ? '1' : '0')
  },
  SET_BOOKINGS_LIST_CHECKINS_SHOW_CHECKIN_CHECKOUT_DATES (state, val) {
    state.bookingsListCheckinsShowCheckinCheckoutDates = val
    localStorage.setItem('LOCAL_SETTING_BOOKINGS_LIST_CHECKINS_SHOW_CHECKIN_CHECKOUT_DATES', val ? '1' : '0')
  },
  SET_BOOKINGS_LIST_CHECKOUTS_SHOW_CHECKIN_CHECKOUT_DATES (state, val) {
    state.bookingsListCheckoutsShowCheckinCheckoutDates = val
    localStorage.setItem('LOCAL_SETTING_BOOKINGS_LIST_CHECKOUTS_SHOW_CHECKIN_CHECKOUT_DATES', val ? '1' : '0')
  },
  SET_BOOKINGS_LIST_CHECKINS_SHOW_REMAINING (state, val) {
    state.bookingsListCheckinsShowRemaining = val
    localStorage.setItem('LOCAL_SETTING_BOOKINGS_LIST_CHECKINS_SHOW_REMAINING', val ? '1' : '0')
  },
  SET_BOOKINGS_LIST_CHECKOUTS_SHOW_REMAINING (state, val) {
    state.bookingsListCheckoutsShowRemaining = val
    localStorage.setItem('LOCAL_SETTING_BOOKINGS_LIST_CHECKOUTS_SHOW_REMAINING', val ? '1' : '0')
  },
  SET_BOOKINGS_LIST_CHECKINS_SHOW_UNPAID (state, val) {
    state.bookingsListCheckinsShowUnpaid = val
    localStorage.setItem('LOCAL_SETTING_BOOKINGS_LIST_CHECKINS_SHOW_UNPAID', val ? '1' : '0')
  },
  SET_BOOKINGS_LIST_CHECKOUTS_SHOW_UNPAID (state, val) {
    state.bookingsListCheckoutsShowUnpaid = val
    localStorage.setItem('LOCAL_SETTING_BOOKINGS_LIST_CHECKOUTS_SHOW_UNPAID', val ? '1' : '0')
  },
  SET_BOOKING_FORM_ALWAYS_SHOW_MAP (state, val) {
    state.bookingFormAlwaysShowMap = val
    localStorage.setItem('LOCAL_SETTING_BOOKING_FORM_ALWAYS_SHOW_MAP', val ? '1' : '0')
  },
  SET_BOOKING_FORM_ALWAYS_SEND_CONFIRMATION_EMAIL (state, val) {
    state.bookingFormAlwaysSendConfirmationEmail = val
    localStorage.setItem('LOCAL_SETTING_BOOKING_FORM_ALWAYS_SEND_CONFIRMATION_EMAIL', val ? '1' : '0')
  },
  SET_BOOKING_FORM_CATEGORY_FILTER_DROPDOWN (state, val) {
    state.bookingFormCategoryFilterDropdown = val
    localStorage.setItem('LOCAL_SETTING_BOOKING_FORM_CATEGORY_FILTER_DROPDOWN', val ? '1' : '0')
  },
  SET_BOOKING_CALENDAR_IS_TOGGLE_LONG_POSITION_NAME (state, val) {
    state.bookingCalendarIsToggleLongPositionName = val
    localStorage.setItem('LOCAL_SETTING_BOOKING_CALENDAR_IS_TOGGLE_LONG_POSITION_NAME', val ? '1' : '0')
  },
  SET_BOOKING_CALENDAR_IS_TOGGLE_SHOW_AREA (state, val) {
    state.bookingCalendarIsToggleShowArea = val
    localStorage.setItem('LOCAL_SETTING_BOOKING_CALENDAR_IS_TOGGLE_SHOW_AREA', val ? '1' : '0')
  },
  SET_STATS_PRODUCT_GROUP_SALES_TABLE_SETTING_SHOW_REGISTER_SALES_ONLY (state, val) {
    state.statsProductGroupSalesTableSettingShowRegisterSalesOnly = val
    localStorage.setItem('LOCAL_SETTING_STATS_PRODUCT_GROUP_SALES_TABLE_SETTING_SHOW_REGISTER_SALES_ONLY', val ? '1' : '0')
  },
  SET_MAP_POSITIONS_GREEN_AVAILABILITY (state, val) {
    state.mapPositionsGreenAvailability = val
    localStorage.setItem('LOCAL_SETTING_MAP_POSITIONS_GREEN_AVAILABILITY', val ? '1' : '0')
  },
  SET_CALENDAR_CATEGORY_FILTER_DROPDOWN (state, val) {
    state.calendarCategoryFilterDropdown = val
    localStorage.setItem('LOCAL_SETTING_CALENDAR_CATEGORY_FILTER_DROPDOWN', val ? '1' : '0')
  },
  SET_CALENDAR_SHOW_TWELVE_MONTHS_QUICK_SCROLL (state, val) {
    state.calendarShowTwelveMonthsQuickScroll = val
    localStorage.setItem('LOCAL_SETTING_CALENDAR_SHOW_TWELVE_MONTHS_QUICK_SCROLL', val ? '1' : '0')
  },
  SET_CALENDAR_PRESERVE_POSITION_IN_GRID (state, val) {
    state.calendarPreservePositionInGrid = val
    localStorage.setItem('LOCAL_SETTING_CALENDAR_PRESERVE_POSITION_IN_GRID', val ? '1' : '0')
  },
  SET_CALENDAR_PRESERVE_CATEGORY_FILTER (state, val) {
    state.calendarPreserveCategoryFilter = val
    localStorage.setItem('LOCAL_SETTING_CALENDAR_PRESERVE_CATEGORY_FILTER', val ? '1' : '0')
  },
  SET_CALENDAR_SHOW_POSITION_RESERVATION_LOCKS (state, val) {
    state.calendarShowPositionReservationLocks = val
    localStorage.setItem('LOCAL_SETTING_CALENDAR_SHOW_POSITION_RESERVATION_LOCKS', val ? '1' : '0')
  },
  SET_CALENDAR_NARROW_ROWS (state, val) {
    state.calendarNarrowRows = val
    localStorage.setItem('LOCAL_SETTING_CALENDAR_NARROW_ROWS', val.toString())
  },
  SET_CALENDAR_EVENT_COLOR_SCHEME (state, val) {
    state.calendarEventColorScheme = val
    localStorage.setItem('LOCAL_SETTING_CALENDAR_EVENT_COLOR_SCHEME', val)
  },
  SET_SHOW_PARK_AS_NOTE_FIRST (state, val) {
    state.showParkAsNoteFirst = val
    localStorage.setItem('LOCAL_SETTING_SHOW_PARK_AS_NOTE_FIRST', val ? '1' : '0')
  },
  SET_PRINT_CHECKIN_CONFIRMATION_AUTOMATICALLY (state, val) {
    state.printCheckinConfirmationAutomatically = val
    localStorage.setItem('LOCAL_SETTING_PRINT_CHECKIN_CONFIRMATION_AUTOMATICALLY', val ? '1' : '0')
  },
  SET_CASH_CALCULATOR_SHOW_ON_SCREEN_BUTTONS (state, val) {
    state.cashCalculatorShowOnScreenButtons = val
    localStorage.setItem('LOCAL_SETTING_CASH_CALCULATOR_SHOW_ON_SCREEN_BUTTONS', val ? '1' : '0')
  },
  SET_CASH_CALCULATOR_SHOW_DENOMINATIONS (state, val) {
    state.cashCalculatorShowDenominations = val
    localStorage.setItem('LOCAL_SETTING_CASH_CALCULATOR_SHOW_DENOMINATIONS', val ? '1' : '0')
  }
}

export const actions = {
  initialise ({ commit }) {
    // OBS: får tänka på att localstorage inte synkas mellan tabbar, så inga viktiga inställningar här
    let val = localStorage.getItem('LOCAL_SETTING_BOOKINGS_LIST_CHECKINS_SHOW_NIGHTS')
    val == null ? val = false : val = (val === '1') // false default
    commit('SET_BOOKINGS_LIST_CHECKINS_SHOW_NIGHTS', val)

    val = localStorage.getItem('LOCAL_SETTING_BOOKINGS_LIST_CHECKOUTS_SHOW_NIGHTS')
    val == null ? val = false : val = (val === '1') // false default
    commit('SET_BOOKINGS_LIST_CHECKOUTS_SHOW_NIGHTS', val)

    val = localStorage.getItem('LOCAL_SETTING_BOOKINGS_LIST_CHECKINS_SHOW_POSITION_NAME_FIRST')
    val == null ? val = false : val = (val === '1') // false default
    commit('SET_BOOKINGS_LIST_CHECKINS_SHOW_POSITION_NAME_FIRST', val)

    val = localStorage.getItem('LOCAL_SETTING_BOOKINGS_LIST_CHECKOUTS_SHOW_POSITION_NAME_FIRST')
    val == null ? val = false : val = (val === '1') // false default
    commit('SET_BOOKINGS_LIST_CHECKOUTS_SHOW_POSITION_NAME_FIRST', val)

    val = localStorage.getItem('LOCAL_SETTING_RECENT_BOOKINGS_SHOW_NIGHTS')
    val == null ? val = true : val = (val === '1') // true default
    commit('SET_RECENT_BOOKINGS_SHOW_NIGHTS', val)

    val = localStorage.getItem('LOCAL_SETTING_RECENT_BOOKINGS_SHOW_POSITION_NAME_FIRST')
    val == null ? val = true : val = (val === '1') // true default
    commit('SET_RECENT_BOOKINGS_SHOW_POSITION_NAME_FIRST', val)

    val = localStorage.getItem('LOCAL_SETTING_RECENT_CHECKINS_CHECKOUTS_SHOW_NIGHTS')
    val == null ? val = false : val = (val === '1') // false default
    commit('SET_RECENT_CHECKINS_CHECKOUTS_SHOW_NIGHTS', val)

    val = localStorage.getItem('LOCAL_SETTING_RECENT_CHECKINS_CHECKOUTS_SHOW_POSITION_NAME_FIRST')
    val == null ? val = false : val = (val === '1') // false default
    commit('SET_RECENT_CHECKINS_CHECKOUTS_SHOW_POSITION_NAME_FIRST', val)

    val = localStorage.getItem('LOCAL_SETTING_RECENT_BOOKINGS_SHOW_CHECKIN_CHECKOUT_DATES')
    val == null ? val = true : val = (val === '1') // true default
    commit('SET_RECENT_BOOKINGS_SHOW_CHECKIN_CHECKOUT_DATES', val)

    val = localStorage.getItem('LOCAL_SETTING_RECENT_CHECKINS_CHECKOUTS_SHOW_CHECKIN_CHECKOUT_DATES')
    val == null ? val = false : val = (val === '1') // false default
    commit('SET_RECENT_CHECKINS_CHECKOUTS_SHOW_CHECKIN_CHECKOUT_DATES', val)

    val = localStorage.getItem('LOCAL_SETTING_BOOKINGS_LIST_CHECKINS_SHOW_CHECKIN_CHECKOUT_DATES')
    val == null ? val = false : val = (val === '1') // false default
    commit('SET_BOOKINGS_LIST_CHECKINS_SHOW_CHECKIN_CHECKOUT_DATES', val)

    val = localStorage.getItem('LOCAL_SETTING_BOOKINGS_LIST_CHECKOUTS_SHOW_CHECKIN_CHECKOUT_DATES')
    val == null ? val = false : val = (val === '1') // false default
    commit('SET_BOOKINGS_LIST_CHECKOUTS_SHOW_CHECKIN_CHECKOUT_DATES', val)

    val = localStorage.getItem('LOCAL_SETTING_BOOKINGS_LIST_CHECKINS_SHOW_REMAINING')
    val == null ? val = true : val = (val === '1') // true default
    commit('SET_BOOKINGS_LIST_CHECKINS_SHOW_REMAINING', val)

    val = localStorage.getItem('LOCAL_SETTING_BOOKINGS_LIST_CHECKOUTS_SHOW_REMAINING')
    val == null ? val = true : val = (val === '1') // true default
    commit('SET_BOOKINGS_LIST_CHECKOUTS_SHOW_REMAINING', val)

    val = localStorage.getItem('LOCAL_SETTING_BOOKINGS_LIST_CHECKINS_SHOW_UNPAID')
    val == null ? val = false : val = (val === '1') // false default
    commit('SET_BOOKINGS_LIST_CHECKINS_SHOW_UNPAID', val)

    val = localStorage.getItem('LOCAL_SETTING_BOOKINGS_LIST_CHECKOUTS_SHOW_UNPAID')
    val == null ? val = false : val = (val === '1') // false default
    commit('SET_BOOKINGS_LIST_CHECKOUTS_SHOW_UNPAID', val)

    val = localStorage.getItem('LOCAL_SETTING_BOOKING_FORM_ALWAYS_SHOW_MAP')
    val == null ? val = false : val = (val === '1') // false default
    commit('SET_BOOKING_FORM_ALWAYS_SHOW_MAP', val)

    val = localStorage.getItem('LOCAL_SETTING_BOOKING_FORM_ALWAYS_SEND_CONFIRMATION_EMAIL')
    val == null ? val = false : val = (val === '1') // false default
    commit('SET_BOOKING_FORM_ALWAYS_SEND_CONFIRMATION_EMAIL', val)

    val = localStorage.getItem('LOCAL_SETTING_BOOKING_FORM_CATEGORY_FILTER_DROPDOWN')
    val == null ? val = false : val = (val === '1') // false default
    commit('SET_BOOKING_FORM_CATEGORY_FILTER_DROPDOWN', val)

    val = localStorage.getItem('LOCAL_SETTING_BOOKING_CALENDAR_IS_TOGGLE_LONG_POSITION_NAME')
    val == null ? val = false : val = (val === '1') // false default
    commit('SET_BOOKING_CALENDAR_IS_TOGGLE_LONG_POSITION_NAME', val)

    val = localStorage.getItem('LOCAL_SETTING_BOOKING_CALENDAR_IS_TOGGLE_SHOW_AREA')
    val == null ? val = true : val = (val === '1') // true default
    commit('SET_BOOKING_CALENDAR_IS_TOGGLE_SHOW_AREA', val)

    val = localStorage.getItem('LOCAL_SETTING_STATS_PRODUCT_GROUP_SALES_TABLE_SETTING_SHOW_REGISTER_SALES_ONLY')
    val == null ? val = false : val = (val === '1') // false default
    commit('SET_STATS_PRODUCT_GROUP_SALES_TABLE_SETTING_SHOW_REGISTER_SALES_ONLY', val)

    val = localStorage.getItem('LOCAL_SETTING_MAP_POSITIONS_GREEN_AVAILABILITY')
    val == null ? val = true : val = (val === '1') // true default
    commit('SET_MAP_POSITIONS_GREEN_AVAILABILITY', val)

    val = localStorage.getItem('LOCAL_SETTING_CALENDAR_CATEGORY_FILTER_DROPDOWN')
    val == null ? val = false : val = (val === '1') // false default
    commit('SET_CALENDAR_CATEGORY_FILTER_DROPDOWN', val)

    val = localStorage.getItem('LOCAL_SETTING_CALENDAR_SHOW_TWELVE_MONTHS_QUICK_SCROLL')
    val == null ? val = false : val = (val === '1') // false default
    commit('SET_CALENDAR_SHOW_TWELVE_MONTHS_QUICK_SCROLL', val)

    val = localStorage.getItem('LOCAL_SETTING_CALENDAR_PRESERVE_POSITION_IN_GRID')
    val == null ? val = false : val = (val === '1') // false default
    commit('SET_CALENDAR_PRESERVE_POSITION_IN_GRID', val)

    val = localStorage.getItem('LOCAL_SETTING_CALENDAR_PRESERVE_CATEGORY_FILTER')
    val == null ? val = false : val = (val === '1') // false default
    commit('SET_CALENDAR_PRESERVE_CATEGORY_FILTER', val)

    val = localStorage.getItem('LOCAL_SETTING_CALENDAR_SHOW_POSITION_RESERVATION_LOCKS')
    val == null ? val = true : val = (val === '1') // true default
    commit('SET_CALENDAR_SHOW_POSITION_RESERVATION_LOCKS', val)

    val = localStorage.getItem('LOCAL_SETTING_CALENDAR_NARROW_ROWS')
    val == null ? val = 3 : val = (val === '1') ? 1 : (val === '2') ? 2 : 3 // 3 default
    commit('SET_CALENDAR_NARROW_ROWS', val)

    val = localStorage.getItem('LOCAL_SETTING_CALENDAR_EVENT_COLOR_SCHEME')
    if (val == null) {
      val = 'status' // status default
    }
    commit('SET_CALENDAR_EVENT_COLOR_SCHEME', val)

    val = localStorage.getItem('LOCAL_SETTING_SHOW_PARK_AS_NOTE_FIRST')
    val == null ? val = false : val = (val === '1') // false default
    commit('SET_SHOW_PARK_AS_NOTE_FIRST', val)

    val = localStorage.getItem('LOCAL_SETTING_PRINT_CHECKIN_CONFIRMATION_AUTOMATICALLY')
    val == null ? val = false : val = (val === '1') // false default
    commit('SET_PRINT_CHECKIN_CONFIRMATION_AUTOMATICALLY', val)

    val = localStorage.getItem('LOCAL_SETTING_CASH_CALCULATOR_SHOW_ON_SCREEN_BUTTONS')
    val == null ? val = true : val = (val === '1') // true default
    commit('SET_CASH_CALCULATOR_SHOW_ON_SCREEN_BUTTONS', val)

    val = localStorage.getItem('LOCAL_SETTING_CASH_CALCULATOR_SHOW_DENOMINATIONS')
    val == null ? val = false : val = (val === '1') // false default
    commit('SET_CASH_CALCULATOR_SHOW_DENOMINATIONS', val)
  }
}
